import type { TourDefinition } from '../tours.types';

export const MODAL_AGREGAR_GRUPOS_TOUR: TourDefinition = {
  id: 'modal_agregar_grupos_help',
  remember: true,
  steps: [
    {
      element: '[data-tour="selector-grupos"]',
      popover: {
        title: 'Selecciona un grupo',
        description:
          'Desde este selector puedes buscar y elegir el grupo cuyos miembros participarán en el proceso de firma.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="columna-acciones"]',
      popover: {
        title: 'Gestión de participantes',
        description:
          'Utiliza el botón de esta columna para excluir personas específicas del grupo. Los usuarios excluidos no recibirán la solicitud de firma de los documentos.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="seccion-excluidos"]',
      popover: {
        title: 'Personas excluidas',
        description:
          'Aquí se muestran los miembros del grupo que han sido excluidos del proceso de firma. Puedes revisar en todo momento quiénes no participarán.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="seccion-excluidos-acciones"]',
      popover: {
        title: 'Revertir exclusiones',
        description:
          'Desde esta sección puedes volver a incluir a un miembro previamente excluido, restaurándolo al proceso de firma.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="btn-guardar-seleccion-grupo"]',
      popover: {
        title: 'Confirmar selección',
        description:
          'Haz clic en guardar para confirmar el grupo seleccionado y las exclusiones realizadas antes de continuar con el proceso.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
